module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("KQV3i"))).then(() => parcelRequire('8rm4T'));